<h2 mat-dialog-title>Nuevo Cobro</h2>

<mat-dialog-content class="bill-dialog">
  <p class="bill-patient">{{ data.patientName }}</p>

  <div class="bill-grid">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Doctor</mat-label>
      @if (picksDoctor) {
        <mat-select
          [ngModel]="doctorUid()"
          (ngModelChange)="doctorUid.set($event)"
          [disabled]="loadingDoctors() || saving()"
        >
          @for (doctor of doctors(); track doctor.uid) {
            <mat-option [value]="doctor.uid">{{ doctorLabel(doctor) }}</mat-option>
          }
        </mat-select>
      } @else {
        <input matInput [value]="selectedDoctorLabel()" disabled />
      }
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Fecha de vencimiento</mat-label>
      <input
        matInput
        type="date"
        [ngModel]="dueDate()"
        (ngModelChange)="dueDate.set($event)"
        [disabled]="saving()"
      />
    </mat-form-field>
  </div>

  <div class="bill-add">
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="bill-concept">
      <mat-label>Producto</mat-label>
      <mat-select
        [ngModel]="productId()"
        (ngModelChange)="selectProduct($event)"
        [disabled]="saving() || loadingProducts() || products().length === 0"
      >
        @for (product of products(); track product.id) {
          <mat-option [value]="product.id">
            {{ product.name }} · {{ formatMoney(product.price) }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="bill-price">
      <mat-label>Precio</mat-label>
      <input
        matInput
        inputmode="decimal"
        [ngModel]="unitPrice()"
        (ngModelChange)="unitPrice.set($event)"
        [disabled]="saving() || priceLocked() || !selectedProduct()"
      />
    </mat-form-field>
    <button
      mat-stroked-button
      type="button"
      [disabled]="saving() || !selectedProduct()"
      (click)="addItem()"
    >
      Agregar
    </button>
  </div>

  @if (items().length === 0) {
    <p class="bill-hint">Elija un producto del consultorio. Si lo repite al mismo precio, se suma a la cantidad.</p>
  } @else {
    <ul class="bill-items">
      @for (item of items(); track item.productId + item.unitPrice; let index = $index) {
        <li>
          <span class="bill-item-name">{{ item.name }} · {{ formatMoney(item.unitPrice) }}</span>
          <input
            class="bill-qty"
            type="number"
            min="1"
            step="1"
            [ngModel]="item.quantity"
            (ngModelChange)="setQuantity(index, $event)"
            [disabled]="saving()"
            aria-label="Cantidad"
          />
          <button mat-icon-button type="button" aria-label="Quitar" [disabled]="saving()" (click)="removeItem(index)">
            <mat-icon>close</mat-icon>
          </button>
        </li>
      }
    </ul>
  }

  @if (error()) {
    <p class="bill-error" role="alert">{{ error() }}</p>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" [disabled]="saving()" (click)="dialogRef.close()">Cancelar</button>
  <button mat-flat-button color="primary" type="button" [disabled]="saving()" (click)="save()">
    {{ saving() ? 'Guardando…' : 'Guardar cobro' }}
  </button>
</mat-dialog-actions>
